import { connectorSessionGuard, socialUserInfoGuard, } from '@logto/connector-kit';
import { z } from 'zod';
import { VerificationType } from './verification-type.js';
export const socialVerificationRecordDataGuard = z.object({
    id: z.string(),
    connectorId: z.string(),
    type: z.literal(VerificationType.Social),
    socialUserInfo: socialUserInfoGuard.optional(),
    connectorSession: connectorSessionGuard.optional(),
});
